import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "./axios";

import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

import '../src/assets/styles/style.css';
import '../src/assets/styles/jobLists.scss';
import '../src/assets/styles/authForms.scss';
import '../src/assets/styles/responseModal.scss';
import 'flatpickr/dist/flatpickr.css';

import '@vueform/multiselect/themes/default.css';

createApp(App).use(store).use(router).mount('#app')
